/*
frontend web
src/app/NovaConta/novacontamodal.jsx
data/hora: 8/7/26w / 16h06
autor: WdePaula / MVinfo

*/


import {Link} from 'react-router-dom';
import "./novaconta.css";
// import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png'
import AgendexBrandLogo from '../../Assets/agendex/agendexLogoResponsivo';

function NovaContaModal(){
    const ano = new Date().getFullYear();

    return (
        <section id="novaconta" className="py-5 d-flex align-items-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            
            {/* ESTILOS CSS INCORPORADOS PARA EVITAR ERROS DE RESOLUÇÃO */}
            <style>{`
                #novaconta {
                    width: 100%;
                    margin: 0;
                    padding: 0;
                }
                .novaconta-container {
                    max-width: 900px !important;
                }
                .fade-in {
                    animation: fadeInPortal 0.4s ease-out forwards;
                }
                @keyframes fadeInPortal {
                    from {
                        opacity: 0;
                        transform: translateY(15px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .hover-scale {
                    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
                }
                .hover-scale:hover {
                    transform: scale(1.02);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
                }
                .card-gateway-cliente {
                    background-color: #212529;
                    background-image: linear-gradient(145deg, #212529 0%, #2c3034 100%);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease;
                }
                .card-gateway-cliente:hover {
                    transform: translateY(-5px);
                }
                .card-gateway-prestador {
                    background-color: #f05837;
                    background-image: linear-gradient(145deg, #f05837 0%, #d94320 100%);
                    box-shadow: 0 15px 30px rgba(240, 88, 55, 0.15);
                    transition: transform 0.3s ease;
                }
                .card-gateway-prestador:hover {
                    transform: translateY(-5px);
                }
                .btn-white:hover {
                    background-color: #f8f9fa !important;
                }
                @media (max-width: 768px) {
                    .novaconta-container {
                        padding-left: 20px;
                        padding-right: 20px;
                    }
                    .card-gateway-cliente, 
                    .card-gateway-prestador {
                        padding: 30px !important;
                    }
                    .display-6 {
                        font-size: 1.8rem !important;
                    }
                }
            `}</style>

            <div className="container novaconta-container">
                
                {/* LOGO CENTRALIZADO SUPERIOR */}
                <div className="d-flex justify-content-center mb-5 fade-in">
                    <div className="bg-white px-4 py-3 rounded-4 shadow-sm">
                        <AgendexBrandLogo subtitle="CRIAR NOVA CONTA" />
                    </div>
                </div>

                {/* GRID DE SELEÇÃO DE CADASTRO */}
                <div className="row justify-content-center align-items-stretch g-4 fade-in">
                    
                    {/* CARD 1: CLIENTE (CONSUMIDOR) */}
                    <div className="col-md-6 d-flex">
                        <div className="card w-100 border-0 rounded-4 text-white shadow-lg overflow-hidden d-flex flex-column justify-content-between p-4 p-md-5 card-gateway-cliente">
                            <div>
                                <span className="badge bg-primary px-3 py-2 rounded-pill mb-3 text-uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '1px' }}>Consumidor</span>
                                <h2 className="display-6 fw-bold mb-3">Sou Cliente</h2>
                                <p className="text-muted mb-4 text-white-50">
                                    Quero encontrar salões, barbearias, petshops ou clínicas perto de mim e realizar meus agendamentos online de forma rápida e gratuita.
                                </p>
                            </div>
                            <div className="mt-4">
                                <Link 
                                    to="/app/novaconta/cliente" 
                                    className="btn btn-light btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale d-flex align-items-center justify-content-center gap-2"
                                    style={{ color: '#212529', textDecoration: 'none' }}
                                >
                                    Criar Conta de Cliente
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* CARD 2: PRESTADOR (EMPRESA / PROFISSIONAL) */}
                    <div className="col-md-6 d-flex">
                        <div className="card w-100 border-0 rounded-4 text-white shadow-lg overflow-hidden d-flex flex-column justify-content-between p-4 p-md-5 card-gateway-prestador">
                            <div>
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                    <span className="badge bg-dark bg-opacity-25 px-3 py-2 rounded-pill text-uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '1px' }}>Profissional / SaaS</span>
                                    <span className="badge bg-warning text-dark px-3 py-2 rounded-pill fw-bold" style={{ fontSize: '10px' }}>*30 dias grátis</span>
                                </div>
                                <h2 className="display-6 fw-bold mb-3">Sou Profissional</h2>
                                <p className="text-white text-opacity-75 mb-4">
                                    Quero digitalizar minha agenda, receber marcações automáticas de clientes pelo WhatsApp, gerenciar minha equipe e reduzir faltas.
                                </p>
                            </div>
                            <div className="mt-4">
                                <Link 
                                    to="/app/novaconta/prestador" 
                                    className="btn btn-white btn-lg w-100 py-3 fw-bold rounded-3 shadow-sm transition-all hover-scale d-flex align-items-center justify-content-center gap-2"
                                    style={{ backgroundColor: '#ffffff', color: '#f05837', border: 'none', textDecoration: 'none' }}
                                >
                                    Cadastrar Meu Negócio
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                    </svg>
                                </Link>
                            </div>
                            <p className="text-warning mt-5 small">
                                (*) Consulte condições, pois pode ser revogado a qualquer momento e sem prévio aviso, ou que no momento do cadastro esteja com 7, 14 ou 28 dias gratuitos ou nenhum.
                            </p>
                        </div>
                    </div>

                </div>

                {/* RODAPÉ DO GATEWAY */}
                <div className="text-center mt-5 fade-in">
                    <Link to="/app/login" className="btn btn-outline-secondary px-4 py-2 rounded-pill fw-semibold text-sm shadow-sm transition-all text-decoration-none">
                        Já tenho uma conta. Toque para fazer login.
                    </Link>
                    <p className="text-secondary mt-3 small">
                        Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}
                    </p>
                </div>

            </div>
        </section>
    );
}
    
    export default NovaContaModal;
